import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Form, Button } from 'react-bootstrap';
import { DataGrid } from '@mui/x-data-grid';
import * as XLSX from 'xlsx';

const VentasPorHora = () => {
  const [periodos, setPeriodos] = useState([]);
  const [seleccionados, setSeleccionados] = useState([]);
  const [tabla, setTabla] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(24);

  useEffect(() => {
    axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/estadisticas/periodos-cargados')
      .then(res => setPeriodos(res.data.periodos))
      .catch(err => console.error('Error al obtener periodos', err));
  }, []);

  const handlePeriodoChange = (e) => {
    const values = Array.from(e.target.selectedOptions, o => o.value);
    setSeleccionados(values);
  };

  const fetchDatos = () => {
    if (seleccionados.length === 0) return;

    setLoading(true);
    axios.get('https://us-central1-inprojuy-f1173.cloudfunctions.net/app/api/estadisticas/ventas-por-hora', {
      params: { periodos: seleccionados }
    }).then(res => {
      const datos = res.data.detalle.map((item, index) => ({
        id: index + 1,
        hora: item.hora,
        total: item.total,
        promedio: item.promedio
      }));

      // Total general
      const totalRow = {
        id: datos.length + 1,
        hora: 'TOTAL',
        total: datos.reduce((acc, d) => acc + d.total, 0),
        promedio: datos.reduce((acc, d) => acc + d.promedio, 0),
      };

      setTabla([...datos, totalRow]);
      setLoading(false);
    }).catch(err => {
      console.error('Error al obtener datos', err);
      setLoading(false);
    });
  };

  const exportarExcel = () => {
    const ws = XLSX.utils.json_to_sheet(tabla);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'VentasPorHora');
    XLSX.writeFile(wb, 'ventas_por_hora.xlsx');
  };

  const formatoMoneda = (valor) =>
    valor.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

  const columns = [
    { field: 'hora', headerName: 'Hora', width: 100 },
    {
      field: 'total',
      headerName: 'Total',
      width: 180,
      type: 'number',
      valueFormatter: ({ value }) => formatoMoneda(value || 0),
    },
    {
      field: 'promedio',
      headerName: 'Promedio',
      width: 180,
      type: 'number',
      valueFormatter: ({ value }) => formatoMoneda(value || 0),
    },
  ];

  return (
    <Container fluid className="mt-4">
      <h3 className="text-center mb-3">Ventas por Hora</h3>

      <Form.Group controlId="periodoSelect">
        <Form.Label>Seleccionar Períodos</Form.Label>
        <Form.Control as="select" multiple onChange={handlePeriodoChange}>
          {periodos.map(p => <option key={p} value={p}>{p}</option>)}
        </Form.Control>
      </Form.Group>

      <div className="d-flex gap-2 mt-3 mb-3">
        <Button onClick={fetchDatos} variant="primary">Consultar</Button>
        <Button onClick={exportarExcel} variant="success" disabled={tabla.length === 0}>
          Exportar a Excel
        </Button>
      </div>

      <div style={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={tabla}
          columns={columns}
          loading={loading}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[12, 24, 48]}
          pagination
        />
      </div>
    </Container>
  );
};

export default VentasPorHora;
